// extracted by css-extract-rspack-plugin
export default {"dimmer":"dimmer-of6smq","loader":"loader-vPpuRn","relative":"relative-bMluvs","active":"active-GLJMGA","dimmerContent":"dimmerContent-BIEt3Z"};